import { Avatar } from 'react-chat-elements';
import Modal from 'react-bootstrap/Modal';
import {useState,useEffect, useLayoutEffect, useRef} from 'react';
import Logo from '../../images/privaposts-butterfly_64.png';
import { s3Link, NOTIFICATION_TYPE } from '../../utils/constants';
import { captureMessage } from '@sentry/react';
import DefaultAvatar from '../../images/default-avatar.jpg';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string'
import { isLogin } from '../../utils/helper';

const GlobalNotification = () => {
  const history = useHistory();
  const notificationContent = useRef(null);

  const [show, setShow] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [read, setRead] = useState(null)

  const getNotifications = () => {
    if (isLogin()) {
        axios.get('/api/notifications', {
            params: {
                filter: NOTIFICATION_TYPE.FREE_SUBSCRIPTION,
                all: true,
                status: 0
            }
        })
        .then(response => {
            setNotifications(response.data)
        })
        .catch(error => {
            captureMessage(error)
        })
    }
  }

  const handleClose = async (e, notification, redirect=false) => {
    if (e) {
      e.preventDefault()
    }

    await axios.patch('/api/notifications', {
      ids: notification.id
    })
    .catch(error => {
      captureMessage(error)
    })

    let tmps = [...show]
    const index = tmps.indexOf(notification.id)

    if (index >= 0) {
      tmps.splice(index, 1)
    }
    setShow(tmps)

    if (redirect) {
      history.push(`/${notification.pu.login}`)
    }
  }

  useEffect(() => {
    if (notifications.length > 0) {
      setShow(notifications.map(data => data.id))
    }
  }, [notifications])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      getNotifications()
    });

    getNotifications()

    // get query strinf read
    const parsed = queryString.parse(location.search);

    if (parsed.read) {
      setRead(parsed.read)
    }

    // This function will be invoked on component unmount and will clean up
    // the event listener.
    return () => {
      unlisten();
    };
  }, [])

  useLayoutEffect(() => {
    $(document).on('click', '.notifications__content a', async function (event) {
      event.preventDefault()
      const self = $(this)
      await handleClose(event, { id: self.data('id')})
      window.location = self.attr('href')
    })
  }, [])


  return notifications.map((notification) => notification.id != read && <Modal
          key={notification.id}
          show={show.indexOf(notification.id) >= 0}
          className="fundModal globalNotificationModal"
          onHide={() => handleClose(notification)}
          backdrop="static"
          keyboard={false}
          backdropClassName="global-notification-backdrop"
          animation={false}
        >
          <Modal.Body>
            <div className="notifications">
              <div className="notifications__logo">
                <img src={Logo} />
              </div>

              <div ref={notificationContent} className="notifications__content" dangerouslySetInnerHTML={{__html: notification.content}} />
              <div className="notifications__avatar">
              <span
                style={{
                  border: '2px solid #fff',
                  borderRadius: '50%',
                  display: 'inline-block'
                }}
              >
                <a href="#" onClick={(e) => handleClose(e, notification, true)}>
                  {
                    notification.pu && notification.pu.profile_pic
                      ? (
                        notification.pu.profile_photo_updated_at
                        ? <img src={`${s3Link}/${notification.pu.id}/profile_photo.jpg?t=${notification.pu.profile_photo_updated_at}`} width="62" className='avatar' />
                        : <img src={`${s3Link}/${notification.pu.id}/profile_photo.jpg?t=${(new Date().valueOf())}`} width="62" className='avatar' />
                      )
                      : <img src={DefaultAvatar} width="62" className='avatar' />
                  }
                </a>
              </span>
              </div>
              <div className="notifications__close">
                <a href="#" onClick={(e) => handleClose(e, notification)}>
                  <i className="fa-solid fa-xmark"></i>
                </a>
              </div>
            </div>
          </Modal.Body>
        </Modal>
    )
}

export default GlobalNotification;
